import { NarrativeStore } from '@assets/model/NarrativeStore';
import { SideChatMessage } from '@assets/model/SideChatStore';
import AttachFactsMessage from './AttachFacts/AttachFacts';
import RecommendNarrativeItemMessage from './RecommendNarrativeItemMessage/RecommendNarrativeItemMessage';
import TextMessage from './TextMessage/TextMessage';

export type ReplyMessageType =
    | 'text'
    | 'recommend_L2'
    | 'recommend_L3'
    | 'attach_facts';

export class ReplyMessageFactory {
    static createMessageByType(
        type: ReplyMessageType,
        data: SideChatMessage,
        key: string,
        narStore: NarrativeStore
    ) {
        switch (type) {
            case 'text':
                return <TextMessage key={key} message={data} />;

            case 'recommend_L3':
            case 'recommend_L2':
                return (
                    <RecommendNarrativeItemMessage
                        key={key}
                        message={data}
                        narStore={narStore}
                    />
                );
            case 'attach_facts':
                return (
                    <AttachFactsMessage
                        key={key}
                        message={data}
                        narStore={narStore}
                    />
                );
            default:
                console.log(`Unknown message type: ${type}`);
                return <div>Unknown message type {type}</div>;
        }
    }
}
